import React from 'react';
import PropTypes from 'prop-types';
import NodeContentHeaderTools from '../NodeContentHeaderTools';
import { HubTopSection } from './styles';

const TopSection = ({ panel, options, nodeData }) => {
  const { userToken, viewer } = options;

  return (
    <HubTopSection>
      <NodeContentHeaderTools
        userToken={userToken}
        nodeData={nodeData}
        panel={panel}
        viewer={viewer}
        showVoiceOverTool={true}
        showFullScreenTool={true}
        darkMode={true}
      />
    </HubTopSection>
  );
};

export default TopSection;

TopSection.propTypes = {
  panel: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  nodeData: PropTypes.object.isRequired,
};
